import { useState, useEffect } from 'react'
import Navbar from '../components/Navbar'
import ListingCard from '../components/ListingCard'
import { supabase } from '../lib/supabase'

const SEED = [
  { id:'s1', name:'Big Winds', category:'shop', discipline:'multi', region:'North America', city:'Hood River, OR', country:'USA', description:'Legendary Gorge shop since 1987. Full lessons and rentals for windsurfing, kiteboarding, and wingfoil.', website_url:'https://www.bigwinds.com', is_featured:true, is_verified:true, vote_count:142 },
  { id:'s2', name:'René Egli Fuerteventura', category:'shop', discipline:'multi', region:'Europe', city:'Sotavento, Fuerteventura', country:'Spain', description:'Legendary center at Sotavento Lagoon — host of the PWA World Championships.', website_url:'https://www.rene-egli.com', is_featured:false, is_verified:true, vote_count:98 },
  { id:'s3', name:'HST Windsurf, Kitesurf & WingFoil', category:'school', discipline:'multi', region:'North America', city:'Kanaha Beach, Maui', country:'USA', description:"Maui's oldest and largest water sports school.", website_url:'https://hstwindsurfing.com', is_verified:true, vote_count:87 },
  { id:'s4', name:'Flisvos Sport Club Naxos', category:'club', discipline:'multi', region:'Europe', city:'Mikri Vigla, Naxos', country:'Greece', description:'Naxos is the wind sports capital. Flisvos hosts PWA events at Mikri Vigla.', website_url:'https://www.flisvos-sportclub.com', is_verified:true, vote_count:65 },
  { id:'s5', name:'Kite Club Hatteras', category:'club', discipline:'kite', region:'North America', city:'Cape Hatteras, NC', country:'USA', description:'One of the most famous kite clubs in the US at the legendary Canadian Hole.', website_url:'https://www.kiteclubhatteras.com', is_verified:true, vote_count:54 },
  { id:'s6', name:'Dakhla Attitude', category:'school', discipline:'multi', region:'Africa & Middle East', city:'Dakhla', country:'Morocco', description:'40km flat-water lagoon, near-year-round wind, and warm water.', website_url:'https://www.dakhlaattitude.com', is_verified:true, vote_count:49 },
]

export default function VotePage() {
  const [listings, setListings] = useState(SEED)
  const [loading, setLoading]   = useState(true)

  useEffect(() => { fetchTop() }, [])

  async function fetchTop() {
    const { data } = await supabase
      .from('listings')
      .select('*')
      .eq('status', 'approved')
      .order('vote_count', { ascending: false })
      .limit(20)
    if (data && data.length) setListings(data)
    setLoading(false)
  }

  const winner = listings[0]
  const rest   = listings.slice(1)

  return (
    <div>
      <Navbar />
      <div className="page-wrap">

        {/* Header */}
        <div style={{ textAlign:'center', marginBottom:32 }}>
          <img src="/logo.png" alt="Wind Sports Directory" style={{ height:52, width:'auto', margin:'0 auto 14px', display:'block' }} />
          <div className="page-title" style={{ textAlign:'center' }}>Community Vote</div>
          <div className="page-sub" style={{ textAlign:'center', marginBottom:16 }}>
            Vote for your favorite club, school, or shop. The top vote-getter each month gets a free featured spot.
            <br/>Log in to vote — one vote per listing per month.
          </div>
          <div style={{ display:'inline-flex', alignItems:'center', gap:8, background:'#fffbeb', border:'1.5px solid var(--gold)', borderRadius:8, padding:'8px 16px', fontSize:13, color:'#92400e' }}>
            🏆 Current period: <strong style={{ marginLeft:4 }}>{new Date().toLocaleString('en-US',{month:'long',year:'numeric'})}</strong>
          </div>
        </div>

        {/* #1 Winner — highlighted */}
        {!loading && winner && (
          <div style={{ marginBottom:32 }}>
            <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:14 }}>
              <div style={{ background:'linear-gradient(135deg,var(--gold),#f59e0b)', borderRadius:8, padding:'6px 14px', display:'flex', alignItems:'center', gap:7 }}>
                <span style={{ fontSize:16 }}>🥇</span>
                <span style={{ fontFamily:'var(--mono)', fontSize:11, fontWeight:700, color:'#fff', letterSpacing:'1.5px', textTransform:'uppercase' }}>Top Voted This Month</span>
              </div>
              <span style={{ fontSize:12, color:'var(--gray-400)', fontFamily:'var(--mono)' }}>▲ {winner.vote_count} votes</span>
            </div>
            <div style={{ maxWidth:360 }}>
              <ListingCard listing={{ ...winner, is_featured: true }} />
            </div>
          </div>
        )}

        {/* Divider */}
        {rest.length > 0 && (
          <div style={{ fontFamily:'var(--mono)', fontSize:11, fontWeight:700, color:'var(--gray-400)', letterSpacing:2, textTransform:'uppercase', borderBottom:'1px solid var(--gray-200)', paddingBottom:10, marginBottom:20 }}>
            More Listings — Cast Your Vote
          </div>
        )}

        {/* Rest of leaderboard with rank banners on #2 and #3 */}
        <div className="cards-grid" style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(280px,1fr))', gap:18 }}>
          {rest.map((l, i) => (
            <div key={l.id} style={{ position:'relative' }}>
              {/* Rank banner for #2 and #3 */}
              {i < 2 && (
                <div style={{
                  position:'absolute', top:0, left:0, right:0, zIndex:5,
                  background: i===0 ? 'rgba(107,114,128,.85)' : 'rgba(180,83,9,.8)',
                  backdropFilter:'blur(4px)',
                  color:'#fff', padding:'4px 12px',
                  fontSize:10, fontWeight:700, fontFamily:'var(--mono)',
                  letterSpacing:1, textTransform:'uppercase',
                  display:'flex', alignItems:'center', gap:6,
                  borderRadius:'14px 14px 0 0',
                }}>
                  {i===0 ? '🥈 2nd Most Voted' : '🥉 3rd Most Voted'}
                  <span style={{ marginLeft:'auto', opacity:.8 }}>▲ {l.vote_count}</span>
                </div>
              )}
              <div style={{ paddingTop: i < 2 ? 24 : 0 }}>
                <ListingCard listing={l} />
              </div>
            </div>
          ))}
        </div>

        {loading && <p style={{ textAlign:'center', color:'var(--gray-400)', padding:'60px 0' }}>Loading…</p>}
      </div>
    </div>
  )
}
